import React, { ReactNode, useCallback, useState } from 'react';

export interface DropdownProps {
    children?: ReactNode;
    menu?: ReactNode;

    label?: ReactNode;
    buttonClassName?: string;
    isOpen?: boolean;
}

function getClassNames(open: boolean) {
    return {
        dropdown: `dropdown`,
        menu: `dropdown-menu force-to-front ${open ? 'show' : ''}`
    };
}

export function Dropdown(props: DropdownProps) {
    const [open, setOpen] = useState(false);
    const classNames = getClassNames(open || props.isOpen || false);

    const handleToggle = useCallback(
        function() {
            setOpen(x => !x);
        },
        [setOpen]
    );

    const handleBlur = useCallback(
        function() {
            setTimeout(function() {
                setOpen(() => false);
            }, 300);
        },
        [setOpen]
    );

    return (
        <div className={classNames.dropdown}>
            {props.label && (
                <button type="button" className={`btn ` + props.buttonClassName} onClick={handleToggle} onBlur={handleBlur}>
                    {props.label}
                </button>
            )}
            {props.children}
            <div className={classNames.menu}>{props.menu}</div>
        </div>
    );
}
